import {
  scalerWithOptions,
  yScalerWithOptions,
} from 'sleepio/components/screens/SessionsScreen/utils/scaler';

export const scalerVertical = yScalerWithOptions({ minScale: 0.6 });
export const scalerHorizontal = scalerWithOptions({});
export const scalerHorizontalMobileWeb = scalerWithOptions({ minScale: 0.8 });
